import React, { ReactElement } from "react";
import * as styles from "./CruiseRecapItem.module.scss";
import clsx from "clsx";

type Props = {
  title: ReactElement | string;
  value: ReactElement | string | undefined;
  className?: string;
};

const CruiseRecapItem: React.FC<Props> = ({ title, value, className }) => {
  return (
    <div className={clsx(styles.wrapper, className)}>
      <dt>{title}</dt>
      <dd>{value}</dd>
    </div>
  );
};

export default CruiseRecapItem;
